export default {"src":"/_next/static/media/key.196e72a0.svg","height":164,"width":65,"blurWidth":0,"blurHeight":0};